import React, { useState, useEffect } from 'react';
import { Form, FormControl, Button, Navbar, Container, Nav, NavDropdown, Row, Col, Modal } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import '../App.css';

function MenuComp() {
  const [menuSearchQuery, setMenuSearchQuery] = useState('');
  const [items, setItems] = useState([]);
  const [showModal, setShowModal] = useState(false); // For showing modal

  const navigate = useNavigate();

  useEffect(() => {
    // Fetch the JSON items when the component loads
    fetch('/items.json?v=2')
      .then(response => response.json())
      .then(data => {
        setItems(data);
      })
      .catch(error => console.error('Error fetching data:', error));
  }, []);

  const handleMenuSearchChange = (e) => {
    setMenuSearchQuery(e.target.value);
  };

  const handleMenuSearchSubmit = (e) => {
    e.preventDefault();

    if (menuSearchQuery) {
      // Search for partial matches in all fields of the item object
      const filteredItems = items.filter(item => 
        Object.values(item).some(value => 
          value.toString().toLowerCase().includes(menuSearchQuery.toLowerCase())
        )
      );
    
      if (filteredItems.length === 0) {
        // Show modal if no items are found
        setShowModal(true);
    
        // Close modal automatically after 2 seconds
        setTimeout(() => {
          setShowModal(false);
        }, 2000);
      } else {
        // Navigate to /search and pass the query and results as state
        navigate('/search', { state: { query: menuSearchQuery, results: filteredItems } });
      }
    } else {
      console.error('Query is empty');
    }
    
  };

  const handleCloseModal = () => setShowModal(false);

  return (
    <>
      <Navbar className="custom-navbar mb-5" variant="dark" expand="lg">
        <Container fluid>
          <Row className="w-100 align-items-center">
            {/* Home, Products, and Item Search on the left */}
            <Col xs={12} lg={6} className="d-flex justify-content-start align-items-center mb-3 mb-lg-0">
              <Navbar.Brand href="/home" className="fs-5 text-white bar custom-font">Home</Navbar.Brand>
              <Nav className="ms-3 d-flex align-items-center">
                <NavDropdown title={<span className="text-white fs-5 custom-font">Products</span>} id="products-dropdown">
                <NavDropdown.Item href="/bread" className="custom-font">Fresh Bread</NavDropdown.Item>
                  <NavDropdown.Item href="/pastry" className="custom-font">Danishes & Breakfast</NavDropdown.Item>
                  <NavDropdown.Item href="/cake" className="custom-font">Sheet Cakes</NavDropdown.Item>
                  <NavDropdown.Item href="/rcake" className="custom-font">Round Cakes</NavDropdown.Item>
                  <NavDropdown.Item href="/doughnut" className="custom-font">Krispy Kreme Doughnuts</NavDropdown.Item>
                  <NavDropdown.Item href="/Pies" className="custom-font">Individual Wrap Cake</NavDropdown.Item>
                  <NavDropdown.Item href="/Muffins" className="custom-font">Muffins</NavDropdown.Item>
                  <NavDropdown.Item href="/od" className="custom-font">Other Desserts</NavDropdown.Item>
                  <NavDropdown.Item href="/Iwd" className="custom-font">Individual Wrap Desserts</NavDropdown.Item>
                  <NavDropdown.Item href="/Iwb" className="custom-font">Individual Wrap Breakfast</NavDropdown.Item>
                  <NavDropdown.Item href="/Ids" className="custom-font">Desserts Individual Serving</NavDropdown.Item>
                </NavDropdown>
              </Nav>
            </Col>

            {/* Search Form on the right */}
            <Col xs={12} lg={6} className="d-flex justify-content-end">
              <Form className="d-flex w-100 justify-content-end" onSubmit={handleMenuSearchSubmit}>
                <FormControl
                  type="search"
                  placeholder="Search by NSN"
                  className="me-2"
                  aria-label="Search"
                  value={menuSearchQuery}
                  onChange={handleMenuSearchChange}
                />
                <Button type="submit" variant="outline-light" className='ms-2'>Search</Button>
              </Form>
            </Col>
          </Row>
        </Container>
      </Navbar>

      {/* Modal for no search results */}
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton style={{backgroundColor:'#131333', color:'white'}}>
          <Modal.Title>No Results Found</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{fontWeight:'bold', fontSize:'1.2rem'}}>Please try again.</Modal.Body>
        <Modal.Footer style={{backgroundColor:'#131333', color:'white'}}>
          <Button variant="primary" onClick={handleCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default MenuComp;
